import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { AxiosObservable } from 'axios-observable';
import axiosObservable from 'axios-observable';
import { PROTECTOR_API_URL } from 'config/constants';
import type { PropertyInfoAddressPoints } from '@protector/entities/property/models';
import type { SprayWindowDailySummaryDatum, SprayWindowDailySummaryRequestBody } from '../../../../pages/disease-risk/disease-risk.models';
import type { DateISOString } from '@protector/utils/types';
import WeatherDataSourceEnum from './weather-data-source.enum';
import type { LoadWeatherParams, WeatherBody } from './weather.models';

const protectorApiUrl = PROTECTOR_API_URL;
const filtersMeteoblue =
  '?filters=temp_air_avg,temp_air_max,temp_air_min,wind_speed_avg,precip_sum,precip_probability,humidity_rel_avg,picto_code';
const filtersClimatempo =
  '?filters=temp_air_avg,temp_air_max,temp_air_min,precip_sum,precip_probability,picto_code,humidity_rel_min,humidity_rel_max';

const filtersHourly = '?filters=temp_air_avg,humidity_rel_avg,wind_speed_avg,wind_direction_avg,picto_code';
const dailyForecastsUrl = `${protectorApiUrl}/weather/daily-forecasts`;
const hourlyForecastsUrl = `${protectorApiUrl}/weather/hourly-forecasts`;

export const getWeather = (request: LoadWeatherParams, flagRemoveReverseCoordinates: boolean) => {
  const coordinates = flagRemoveReverseCoordinates ? [request.long, request.lat] : [request.lat, request.long];
  const paramsWeather = {
    geometry: {
      type: 'Point',
      coordinates
    }
  };
  const filterRequest = request.dataSource === WeatherDataSourceEnum.METEOBLUE ? filtersMeteoblue : filtersClimatempo;
  return axiosObservable.post<WeatherBody[]>(`${dailyForecastsUrl}${filterRequest}&provider=${request.dataSource}`, paramsWeather, {
    timeout: 10000
  });
};

export const getWeatherHours = (request: LoadWeatherParams, flagRemoveReverseCoordinates: boolean) => {
  const coordinates = flagRemoveReverseCoordinates ? [request.long, request.lat] : [request.lat, request.long];
  const paramsWeather = {
    geometry: {
      type: 'Point',
      coordinates
    }
  };
  return axiosObservable.post<WeatherBody[]>(`${hourlyForecastsUrl}${filtersHourly}&provider=${request.dataSource}`, paramsWeather, {
    timeout: 10000
  });
};

export const getDiseaseRiskWeatherDates = (
  startDate: DateISOString,
  endDate: DateISOString,
  geometry: PropertyInfoAddressPoints,
  shouldIncludeRain = false
): AxiosObservable<WeatherBody[]> => {
  const filters = `picto_code,temp_air_avg${shouldIncludeRain ? ',precip_sum' : ''}`;

  return axiosObservable.post<WeatherBody[]>(
    `${dailyForecastsUrl}?start_date=${startDate}&end_date=${endDate}&filters=${filters}`,
    {
      geometry
    },
    {
      timeout: 10000
    }
  );
};

export const getDiseaseRiskSprayWindowDailySummary = (
  location: number[],
  countryCode: string
): Promise<AxiosResponse<SprayWindowDailySummaryDatum[]>> => {
  const body: SprayWindowDailySummaryRequestBody = {
    location,
    country_code: countryCode
  };

  return axios.post(`${protectorApiUrl}/v2/spray-status/hourly-count`, body);
};
